import { render, staticRenderFns } from "./UploadFileDialog.vue?vue&type=template&id=467dd58a&scoped=true&"
import script from "@/views/Users/Student/Progress/UploadFileDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Progress/UploadFileDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/Progress/upload-file-dialog.scss?vue&type=style&index=0&id=467dd58a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467dd58a",
  null
  
)

export default component.exports